(function () {
  if (customElements.get('ce-product-media-video') !== undefined) {
    return;
  }

  class ProductMediaVideo extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        root: '[data-root]',
        nativeWrapper: 'div:not([data-root]).plyr',
        iframe: 'iframe',
        buttonFeatured: '.plyr__control--overlaid',
        buttonControlsPlayPause: '[data-plyr="play"]',
      };

      this.elements = null;
      this.plyr = null;
      this.isPlyrReady = false;

      this.handleReady = this.handleReady.bind(this);
      this.handleClickButtonFeatured = this.handleClickButtonFeatured.bind(this);
    }

    get currentState() {
      return this.getAttribute('current-state');
    }

    set currentState(value) {
      this.setAttribute('current-state', value);
    }

    static get observedAttributes() {
      return ['current-state'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed || !this.isPlyrReady) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'current-state':
          if (newValue !== null) {
            switch (newValue) {
              case 'inactive': {
                const keyframes = [
                  { opacity: 0, visibility: 'hidden' },
                  { opacity: 0, visibility: 'visible', offset: 0.2 },
                  { opacity: 1, visibility: 'visible' },
                ];

                const options = { duration: 250, fill: 'both' };

                this.plyr.stop();

                const anim = this.elements.buttonFeatured.animate(keyframes, options);
                anim.addEventListener('finish', () => {
                  anim.commitStyles();
                  anim.cancel();

                  this.elements.iframe?.setAttribute('tabindex', '-1');
                });

                break;
              }
              case 'active': {
                const keyframes = [
                  { opacity: 1, visibility: 'visible' },
                  { opacity: 0, visibility: 'visible', offset: 0.8 },
                  { opacity: 0, visibility: 'hidden' },
                ];

                const options = { duration: 250, fill: 'both' };

                this.plyr.play();

                this.elements.iframe?.removeAttribute('tabindex');

                if (this.currentState === 'active') {
                  this.elements.buttonControlsPlayPause.focus({ preventScroll: true });
                }

                const anim = this.elements.buttonFeatured.animate(keyframes, options);
                anim.addEventListener('finish', () => {
                  anim.commitStyles();
                  anim.cancel();
                });

                break;
              }
            }
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        root: this.querySelector(this.selectors.root),
        iframe: null,
        buttonFeatured: null,
        buttonControlsPlayPause: null,
      };

      this.plyr = new Plyr(this.elements.root, {
        clickToPlay: false,
        controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume'],
        seekTime: 1,
      });

      this.plyr.on('ready', this.handleReady);
    }

    disconnectedCallback() {
      this.elements.buttonFeatured.removeEventListener('click', this.handleClickButtonFeatured);
      this.plyr.destroy();
    }

    handleReady() {
      this.querySelector(this.selectors.nativeWrapper)?.removeAttribute('tabindex');

      this.elements.iframe = this.querySelector(this.selectors.iframe);
      this.elements.buttonFeatured = this.querySelector(this.selectors.buttonFeatured);

      this.elements.buttonControlsPlayPause = this.querySelector(this.selectors.buttonControlsPlayPause);

      this.elements.buttonFeatured.addEventListener('click', this.handleClickButtonFeatured);

      this.currentState = 'inactive';
      this.isPlyrReady = true;

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    handleClickButtonFeatured() {
      this.currentState = 'active';
    }

    blur() {
      this.currentState = 'inactive';
    }
  }

  customElements.define('ce-product-media-video', ProductMediaVideo);
})();
